/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    GuidIdAndLabel,
    GuidIdAndLabelFromJSON,
    GuidIdAndLabelFromJSONTyped,
    GuidIdAndLabelToJSON,
    StationOrLocationItem,
    StationOrLocationItemFromJSON,
    StationOrLocationItemFromJSONTyped,
    StationOrLocationItemToJSON,
} from './';

/**
 * 
 * @export
 * @interface SupplierLocationMappingFormData
 */
export interface SupplierLocationMappingFormData {
    /**
     * 
     * @type {string}
     * @memberof SupplierLocationMappingFormData
     */
    id?: string | null;
    /**
     * 
     * @type {GuidIdAndLabel}
     * @memberof SupplierLocationMappingFormData
     */
    supplier?: GuidIdAndLabel;
    /**
     * 
     * @type {string}
     * @memberof SupplierLocationMappingFormData
     */
    supplierValue?: string | null;
    /**
     * 
     * @type {StationOrLocationItem}
     * @memberof SupplierLocationMappingFormData
     */
    oneAirLocation?: StationOrLocationItem;
    /**
     * 
     * @type {object}
     * @memberof SupplierLocationMappingFormData
     */
    effectiveFrom?: object | null;
    /**
     * 
     * @type {object}
     * @memberof SupplierLocationMappingFormData
     */
    effectiveTo?: object | null;
    /**
     * 
     * @type {boolean}
     * @memberof SupplierLocationMappingFormData
     */
    allowEdit?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SupplierLocationMappingFormData
     */
    disabled?: boolean;
}

export function SupplierLocationMappingFormDataFromJSON(json: any): SupplierLocationMappingFormData {
    return SupplierLocationMappingFormDataFromJSONTyped(json, false);
}

export function SupplierLocationMappingFormDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): SupplierLocationMappingFormData {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'supplier': !exists(json, 'supplier') ? undefined : GuidIdAndLabelFromJSON(json['supplier']),
        'supplierValue': !exists(json, 'supplierValue') ? undefined : json['supplierValue'],
        'oneAirLocation': !exists(json, 'oneAirLocation') ? undefined : StationOrLocationItemFromJSON(json['oneAirLocation']),
        'effectiveFrom': !exists(json, 'effectiveFrom') ? undefined : json['effectiveFrom'],
        'effectiveTo': !exists(json, 'effectiveTo') ? undefined : json['effectiveTo'],
        'allowEdit': !exists(json, 'allowEdit') ? undefined : json['allowEdit'],
        'disabled': !exists(json, 'disabled') ? undefined : json['disabled'],
    };
}

export function SupplierLocationMappingFormDataToJSON(value?: SupplierLocationMappingFormData | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'supplier': GuidIdAndLabelToJSON(value.supplier),
        'supplierValue': value.supplierValue,
        'oneAirLocation': StationOrLocationItemToJSON(value.oneAirLocation),
        'effectiveFrom': value.effectiveFrom,
        'effectiveTo': value.effectiveTo,
        'allowEdit': value.allowEdit,
        'disabled': value.disabled,
    };
}


